import { QueryCache, QueryClient } from '@tanstack/react-query';
import { logSentryError } from '@mews/framework';
import { DistributorThunkDispatch } from '../../types';

declare module '@tanstack/react-query' {
    interface Register {
        queryMeta: {
            logExtra?: object;
        };
    }
}

interface CreateReactQueryClientOptions {
    dispatch: DistributorThunkDispatch;
}

export const createReactQueryClient = ({ dispatch }: CreateReactQueryClientOptions) =>
    new QueryClient({
        defaultOptions: {
            queries: {
                networkMode: 'always',
            },
        },
        queryCache: new QueryCache({
            onError: (error, query) => {
                if (error instanceof Error) {
                    dispatch(logSentryError({ error, extra: query?.meta?.logExtra }));
                }
            },
        }),
    });
